import React, { useState } from "react";
import {
  roundOffValue,
  roundToTwoDecimalPlaces
} from "../../../Utils/DateConverstion";
import { Button, Modal, Card } from "antd";
// import "./Modal.css"
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {useSelector} from 'react-redux'

const getModulePath = (path) => {
  console.log(path);
  if (path.includes("steam-dashboard")) return "steam-dashboard";
  // if (path.includes("electrical-dashboard")) return "electrical-dashboard";
  if (path.includes("temperature-dashboard")) return "temperature-dashboard";
  if (path.includes("air-dashboard")) return "air-dashboard";
  if (path.includes("water-dashboard")) return "water-dashboard";
  return "";
};

const MeterGrid = ({ report }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedReport, setSelectedReport] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const modulePath = getModulePath(location.pathname);
  //   console.log(modulePath)
  const showModal = (item) => {
    setSelectedReport(item);
    setIsModalVisible(true);
    navigate(`/${modulePath}/meter-status/meter-status-popup`);
  };

  const handleCancel = () => {
    setSelectedReport(null);
    setIsModalVisible(false);
    navigate(`/${modulePath}/meter-status`);
  };
  useEffect(() => {
    console.log(report);
  }, []);



  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  // console.log(isdarkMode)
  console.log(report)

  return (
    <div className={`flex px-2 py-2 flex-wrap w-fit gap-3 rounded-md`}>
      {/* {report === null && <p>No Data</p>} */}

      {report?.map((item) => (
        <Card 
          key={item?.meterid}
          onClick={() => showModal(item)}
          className={`min-w-[250px] my-1 mx-1 rounded-md  text-center ${isdarkMode ? 'ant-card-background ' : 'whitemode'}`}
         
          headStyle={{
            backgroundColor:
              item.meterStatus === "OFF"
                ? "#f44336"
                : item.meterStatus === "NO"
                  ? "green"
                : "yellow",
            // color: "black",
          }}
          title={
            <p
              className="py-2 h-auto font-bold"
              style={{
                backgroundColor:
                  item.meterStatus === "OFF"
                    ? "#f44336"
                    : item.meterStatus === "NO"
                      ? "green"
                      : "yellow",
                // color: "black",
                margin: 0,
                padding: "5px 0",
              }}
            >
               {/* {item?.SiteName} */}
               {item?.metername}
            </p>
          }
        >
          <div className={`space-y-3 h-auto font-bold text-black ${isdarkMode ? 'ant-card-body-padding ' : 'whitemode'}`}>
            <p
              className="border-b-2 my-3 h-auto pb-2 w-full"
              style={{
                borderBottomWidth: "2px",
                borderBottom: `2px solid ${item.meterStatus === "OFF" ? "#f44336" : item.meterStatus === "NO" ? "green" : "yellow"}`,
              }}
            >
              {/* VB : {roundOffValue(item?.VB)}  */}
              RH: {roundOffValue(item?.rh)}
            </p>
            <p className="h-auto pb-4"> 
            Temperature: {roundToTwoDecimalPlaces(item?.temperature)}
              {/* Meter ID: {roundToTwoDecimalPlaces(item?.MeterId)}  */}
            </p>
          </div> 
        </Card>
      ))}

      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        closable={false}
        className={`custom-modal ${isdarkMode ? "custom-modal-dark custom-modal-header" : "whitemode"} `}
        // footer={[
        //   <Button className="mr-5 mb-5" key="back" onClick={handleCancel}>
        //     Cancel
        //   </Button>,
        // ]}
        footer={null}
        style={{ padding: 0 }}
        // title={ 
        //   <div
        //     style={{ 
        //       backgroundColor:
        //         selectedReport?.meterStatus === "OFF"
        //           ? "#f44336"
        //           : selectedReport?.meterStatus === "NO"
        //             ? "green"
        //             : "yellow",
        //       color: "white",
        //       padding: 5,
        //       borderRadius: "8px 8px 0 0",
        //     }}
        //   >
        //     Last poll time
        //   </div>
        // }

        title={
          <div 
            style={{
              color:  selectedReport?.meterStatus === "OFF"
              ? "#f44336"
              : selectedReport?.meterStatus === "NO"
                ? "green"
                : "yellow", 
              padding: 5,
              borderRadius: "8px 8px 0 0"
            }}
          >
           Last Poll Time 
          </div>
        }
      >
        <div style={{ padding: 5 }}  className={`text-center font-bold ${isdarkMode ? "text-white" : "whitemode"} `}>
          {selectedReport?.createdON !== "0001-01-01T00:00:00"
            ? new Date(selectedReport?.createdON).toLocaleString()
            : "N/A"}
        </div>


        <div className="flex w-full justify-end mt-5">
          <button
            className="mr-5 mb-5 font-semibold  bg-green-400 hover:text-green-500 hover:border-green-500 hover:bg-white"
            key="back"
            onClick={handleCancel} 
          >
            Cancel
          </button>,
          </div>
      </Modal>
    </div>
  );
};

export default MeterGrid;
